import { useHotkey } from "@tanstack/react-hotkeys";

function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  return (
    target instanceof HTMLInputElement ||
    target instanceof HTMLTextAreaElement ||
    target instanceof HTMLSelectElement ||
    target.isContentEditable
  );
}

function useSpaceConfirmHotkey({
  canInteract,
  canConfirmSelection,
  onConfirmSelection,
}: {
  canInteract: () => boolean;
  canConfirmSelection: () => boolean;
  onConfirmSelection: () => void;
}) {
  useHotkey(
    "Space",
    (event) => {
      if (isEditableTarget(event.target)) return;
      if (!canInteract() || !canConfirmSelection()) return;
      event.preventDefault();
      onConfirmSelection();
    },
    { ignoreInputs: true, conflictBehavior: "allow" },
  );
}

export function useGameHotkeys({
  canInteract,
  canConfirmSelection,
  canUndo,
  canEndTurn,
  onConfirmSelection,
  onCycleUnmovedUnit,
  onUndo,
  onEndTurn,
}: {
  canInteract: () => boolean;
  canConfirmSelection: () => boolean;
  canUndo: () => boolean;
  canEndTurn: () => boolean;
  onConfirmSelection: () => void;
  onCycleUnmovedUnit: () => void;
  onUndo: () => void;
  onEndTurn: () => void | Promise<void>;
}) {
  useSpaceConfirmHotkey({ canInteract, canConfirmSelection, onConfirmSelection });

  useHotkey(
    "Tab",
    (event) => {
      if (isEditableTarget(event.target)) return;
      if (!canInteract()) return;
      event.preventDefault();
      onCycleUnmovedUnit();
    },
    { ignoreInputs: true },
  );

  useHotkey(
    "Mod+Z",
    () => {
      if (!canInteract() || !canUndo()) return;
      onUndo();
    },
    { ignoreInputs: true },
  );

  useHotkey(
    "Mod+E",
    () => {
      if (!canInteract() || !canEndTurn()) return;
      void onEndTurn();
    },
    { ignoreInputs: true },
  );
}
